"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default2 = exports.default = {
  name: 'VarietiesTable',
  props: {
    data: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['delete'],
  computed: {
    tableData: function tableData() {
      return Array.isArray(this.data) ? this.data : [];
    }
  },
  methods: {
    formatType: function formatType(type) {
      if (type === 'rootstock') return 'Porta-enxerto';
      if (type === 'scion') return 'Enxerto';
      return '--';
    },
    formatDate: function formatDate(value) {
      if (!value) return '--';
      var date = value instanceof Date ? value : new Date(value);
      if (Number.isNaN(date.getTime())) return '--';
      return date.toLocaleDateString();
    }
  }
};